import { useState } from "react";
import { ReactSortable } from "react-sortablejs";
import ButtonActionIcon from "../BuilderComponents/ButtonActionIcon";
import { AddAndDeleteInlineIcon } from "../BuilderComponents/Preview/IconPreview";
import Input from "../FormComponents/Input";
import Button from "../FormComponents/Button";
import Label from "../FormComponents/Label";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import { generateObjectId } from "../../utils/objectIdUtils";

const EditTabView = ({ editElementData, setEditElementData, nestedGridData }) => {
  const [tabHeaderName, setTabHeaderName] = useState("");
  const [showInputBox, setShowInputBox] = useState(false);

  const handleFunction = (e) => {
    setEditElementData({ ...editElementData, vertical: e.target.checked });
  };

  const handleTabAction = () => {
    if (showInputBox) {
      addTab();
      setShowInputBox(false);
    } else {
      setShowInputBox(true);
    }
  };

  const addTab = () => {
    if (tabHeaderName.trim().length < 3) return;
    const uniqueId = generateObjectId();
    const newEditTabData = JSON.parse(JSON.stringify(editElementData));
    newEditTabData.config.headerData = [
      ...newEditTabData.config.headerData,
      { display: tabHeaderName, id: uniqueId, icon: "" }
    ];
    newEditTabData.config.bodyData[uniqueId] = [];
    nestedGridData.current[uniqueId] = [];
    setTabHeaderName("");
    setEditElementData(newEditTabData);
  };

  const updateTab = (data) => {
    setEditElementData(data);
  };

  const handleChangeTabOrder = (list) => {
    const newElementData = JSON.parse(JSON.stringify(editElementData));
    const newList = modifyList(list);
    newElementData.config.headerData = newList;
    setEditElementData(newElementData);
  };

  const modifyList = (list) => {
    const modifiedList = list.map((item, index) => {
      if (index === 0) {
        return { ...item, active: true };
      } else {
        return { ...item, active: false };
      }
    });
    return modifiedList;
  };

  return (
    <>
      <div className="flex_row justify_between">
        <Label>Added Tabs</Label>
        <Input type="checkbox" label="Vertical" checked={editElementData.vertical} onChange={handleFunction} />
      </div>

      <ReactSortable
        list={editElementData.config.headerData}
        setList={handleChangeTabOrder}
        animation="200"
        easing="ease-out"
      >
        {editElementData.config.headerData.map((tab) => (
          <SingleTab
            key={tab.id}
            tab={tab}
            editElementData={editElementData}
            updateTab={updateTab}
            nestedGridData={nestedGridData}
          />
        ))}
      </ReactSortable>
      <div className="d_flex justify_end">
        <Button size="small" variant="secondary" onClick={handleTabAction}>
          <MaterialIcon name="add" style={{ fontSize: "14px" }} />
        </Button>
      </div>
      {showInputBox && (
        <div className="inline_tag_items d_block mb_4">
          <Input
            type="text"
            value={tabHeaderName}
            placeholder="Enter Tab Name"
            onChange={(e) => setTabHeaderName(e.target.value)}
          />
        </div>
      )}
    </>
  );
};
const SingleTab = ({ tab, editElementData, updateTab, nestedGridData }) => {
  const [selectedIcon, setSelectedIcon] = useState("");
  const [isEditTab, setIsEditTab] = useState({ id: "", show: false });

  const modifyHeaderData = (id, key, value) => {
    const newEditTabData = JSON.parse(JSON.stringify(editElementData));
    newEditTabData.config.headerData.forEach((head, i) => {
      if (head.id === id) {
        newEditTabData.config.headerData[i][key] = value;
      }
    });
    return newEditTabData;
  };

  const handleEditChange = (e) => {
    const { value } = e.target;
    const updatedTabData = modifyHeaderData(isEditTab.id, "display", value);
    updateTab(updatedTabData);
  };

  const callbackIcons = (data, id) => {
    const updatedTabData = modifyHeaderData(id, "icon", data);
    setSelectedIcon(data);
    updateTab(updatedTabData);
  };

  const handleEditTabName = (data) => {
    setIsEditTab({ id: data.id, show: true });
    setSelectedIcon(data?.icon);
  };

  const deleteTab = (id) => {
    const newEditTabData = JSON.parse(JSON.stringify(editElementData));
    const newData = newEditTabData.config.headerData.filter((head) => head.id !== id);
    newEditTabData.config.headerData = newData;
    delete newEditTabData.config.bodyData[id];

    updateTab(newEditTabData);

    const newNestedGridData = JSON.parse(JSON.stringify(nestedGridData.current));
    delete newNestedGridData[id];
    nestedGridData.current = newNestedGridData;
  };
  const handleBlur = () => {
    setIsEditTab({ id: "", show: false });
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleBlur();
    }
  };

  return (
    <div className="d_flex mb_2">
      <AddAndDeleteInlineIcon icon={selectedIcon} callbackFunction={(data) => callbackIcons(data, tab.id)} />

      <div className="tabView_items w_100" style={{ borderLeft: "none" }} key={tab.id}>
        {isEditTab.show ? (
          <Input
            type="text"
            autoFocus={true}
            onBlur={handleBlur}
            value={tab.display}
            onChange={handleEditChange}
            onKeyDown={handleKeyDown}
          />
        ) : (
          tab.display
        )}

        <div className="tabView_icons">
          {!isEditTab.show && <ButtonActionIcon type="edit" size="xsm" onClick={() => handleEditTabName(tab)} />}
          {editElementData.config.headerData.length > 1 && (
            <ButtonActionIcon type="delete" size="xsm" onClick={() => deleteTab(tab.id)} />
          )}
        </div>
      </div>
    </div>
  );
};
export default EditTabView;
